import React,{useEffect,useState} from 'react';
import baseURL from '../url';
import './PushPrompt.css';
export default function PushPrompt(){
 const [show,setShow]=useState(false);
 useEffect(()=>{ if(typeof window !== 'undefined' && 'Notification' in window && window.Notification.permission==='default') setShow(true); },[]);
 const enable=async()=>{
   try{
    const p=await window.Notification.requestPermission();
    if(p==='granted'){
      await fetch(`${baseURL}/cliente_push_optin.php`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({enabled:true})});
    }
   }catch(e){}
   setShow(false);
 };
 if(!show) return null;
 return <div className='pushPrompt'><div>Recibe notificaciones de pedidos y promociones</div><button onClick={enable}>Aceptar</button></div>;
}
